<div class="image-selection-container">
  @if (!selectedImageUrl) {
    <div class="image-wrapper">
      <app-icon [color]="isDocument ? 'var(--blue)' : 'var(--orange)'" [cssStyle]="{ marginBottom: '-2px' }" [iconName]="'add-image'" size="24px"></app-icon>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="previewImage"></ng-container>
  }

  <!-- Display document name when a document is selected -->
  @if (isDocument && selectedImageUrl) {
    <h4>{{ _selectedFileName }}</h4>
  }

  @if (!selectedImageUrl) {
    <p translate>{{ allowDocument ? 'Drag and drop file here, or click to add file' : 'Drag and drop image here, or click to add image' }}</p>
  } @else {
    <p translate>{{ allowDocument ? 'Drag and drop file here, or click to change file' : 'Drag and drop image here, or click to change image' }}</p>
  }

  <div class="d-flex gap-10">
    <app-button
      (click)="openImageBrowser()"
      [idleText]="(selectedImageUrl ? (isDocument ? 'Change File' : 'Change Image') : allowDocument ? 'Add File' : 'Add Image') | translate"
      cssClass="button-primary-opaque"
    ></app-button>
    @if (!hideClearButton && selectedImageUrl) {
      <button (click)="clearImage()" class="button button-simple button-icon-only">
        <app-icon [cssStyle]="{ marginTop: '-2px' }" [iconName]="willOnlyClearImage ? 'close' : 'trash'" size="20px"></app-icon>
      </button>
    }
  </div>
</div>

<!-- Image Cropper -->

@if (imageCropper && cropperVisible && !isDocument && fileChangeEvent) {
  <div class="image-cropper-container">
    @if (cropperPosition) {
      <image-cropper
        (cropperReady)="cropperReady()"
        (imageCropped)="imageCropped($event)"
        [aspectRatio]="aspectRatio"
        [cropper]="cropperPosition"
        [format]="format"
        [imageChangedEvent]="fileChangeEvent"
        [maintainAspectRatio]="true"
        [onlyScaleDown]="true"
        [output]="'base64'"
        [resizeToHeight]="500"
        [roundCropper]="false"
        autoCrop="false"
      >
      </image-cropper>
    } @else {
      <ng-container *ngTemplateOutlet="defaultCropper"></ng-container>
    }
  </div>
}

<ng-template #previewImage>
  <div [class.--rounded-preview]="isRoundedPreview" [class.full-width-preview]="fullWidthPreview ? 'auto' : ''" class="image-preview">
    @if (!isDocument) {
      <img [src]="selectedImageUrl" alt="user-selected-image" />
    } @else {
      <app-icon [cssStyle]="{ marginBottom: '-1px' }" iconName="document-file" size="135px"></app-icon>
    }
    <!--    <img  src="assets/images/document-file.png" alt="user-selected-document" />-->
    <span class="image-check">
      <app-icon [cssStyle]="{ marginBottom: '-1px' }" color="var(--green)" iconName="check" size="14px"></app-icon>
    </span>
  </div>
</ng-template>

<ng-template #defaultCropper>
  <image-cropper
    (cropperReady)="cropperReady()"
    (imageCropped)="imageCropped($event)"
    [aspectRatio]="aspectRatio"
    [format]="format"
    [imageChangedEvent]="fileChangeEvent"
    [maintainAspectRatio]="true"
    [output]="'base64'"
  >
  </image-cropper>
</ng-template>
